import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tug-of-war-rope',
  template: `
    <div class="rope-arena">
      <!-- Scoreboard header -->
      <div class="scoreboard">
        <div class="team-score team-a-score">
          <span class="team-label" [style.color]="teamAColor">{{ teamAName }}</span>
          <span class="score-num">{{ teamAScore }}</span>
        </div>
        <div class="timer-display">
          <span class="timer-icon">&#9201;</span>
          <span class="timer-value">{{ formatTimer(timerValue) }}</span>
        </div>
        <div class="team-score team-b-score">
          <span class="team-label" [style.color]="teamBColor">{{ teamBName }}</span>
          <span class="score-num">{{ teamBScore }}</span>
        </div>
      </div>

      <!-- GIF field -->
      <div class="pull-field">
        <img src="assets/game-mode/gifs/tugOfWar2.gif" alt="Tug of War" class="tug-gif"
             [style.transform]="'translateX(' + getGifOffset() + 'px)'" />
        <!-- Center dashed line -->
        <div class="center-line"></div>
      </div>
    </div>
  `,
  styles: [`
    .rope-arena {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: calc(8px * var(--game-scale, 1));
      padding: calc(8px * var(--game-scale, 1)) 0;
    }

    .scoreboard {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: calc(8px * var(--game-scale, 1)) calc(16px * var(--game-scale, 1));
    }

    .team-score {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2px;
    }

    .team-label {
      font-size: calc(12px * var(--game-scale, 1));
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .score-num {
      font-size: calc(28px * var(--game-scale, 1));
      font-weight: 900;
      color: white;
    }

    .timer-display {
      display: flex;
      align-items: center;
      gap: calc(6px * var(--game-scale, 1));
      background: rgba(255, 255, 255, 0.08);
      padding: calc(6px * var(--game-scale, 1)) calc(14px * var(--game-scale, 1));
      border-radius: 20px;
    }

    .timer-icon {
      font-size: calc(16px * var(--game-scale, 1));
    }

    .timer-value {
      font-size: calc(18px * var(--game-scale, 1));
      font-weight: 700;
      color: white;
      font-variant-numeric: tabular-nums;
    }

    .pull-field {
      position: relative;
      width: 100%;
      height: calc(320px * var(--game-scale, 1));
      border-radius: 16px;
      overflow: hidden;
      background: #1a2332;
    }

    .tug-gif {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
      transition: transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .center-line {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      width: 2px;
      background: repeating-linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0.4) 0px,
        rgba(255, 255, 255, 0.4) 8px,
        transparent 8px,
        transparent 16px
      );
      z-index: 2;
      pointer-events: none;
    }
  `]
})
export class TugOfWarRopeComponent {
  @Input() position = 0;
  @Input() teamAColor = '#2196F3';
  @Input() teamBColor = '#F44336';
  @Input() teamAName = 'Team 1';
  @Input() teamBName = 'Team 2';
  @Input() teamAScore = 0;
  @Input() teamBScore = 0;
  @Input() timerValue = 0;
  @Input() isPulling = false;

  /** Shift GIF left/right based on rope position (-200..+200 maps to -200px..+200px) */
  getGifOffset(): number {
    return this.position;
  }

  formatTimer(value: number): string {
    const mins = Math.floor(value / 60);
    const secs = value % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
}
